import React, { forwardRef, useEffect, useRef } from "react"

const useCombinedRefs = (
	...refs
) => {
	const targetRef = useRef(null)

	useEffect(() => {
		refs.forEach(
			(
				ref
			) => {
				if (!ref) return

				if (typeof ref === "function") {
					ref(targetRef.current)
				} else {
					ref.current = targetRef.current
				}
			}
		)
	}, [refs])

	return targetRef
}

const IndeterminateCheckbox = forwardRef(({ indeterminate, ...rest }, ref) => {
	const defaultRef = useRef(null)
	const combinedRef = useCombinedRefs(ref, defaultRef)

	useEffect(() => {
		if (combinedRef?.current) {
			combinedRef.current.indeterminate = indeterminate ?? false
		}
	}, [combinedRef, indeterminate])

	return (
		<>
			<input type="checkbox" ref={combinedRef} {...rest} />
		</>
	)
})

export default IndeterminateCheckbox
